var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShippingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39954 1.21895C7.59757 1.10898 7.82036 1.05127 8.04688 1.05127C8.27339 1.05127 8.49618 1.10898 8.69421 1.21895L13.7042 4.00162C13.8081 4.05938 13.8946 4.14386 13.9549 4.2463C14.0151 4.34875 14.0469 4.46544 14.0469 4.58429V10.0743C14.0469 10.3122 13.9834 10.5457 13.8627 10.7508C13.7421 10.9558 13.5688 11.1248 13.3609 11.2403L8.69421 13.8323C8.49618 13.9423 8.27339 14 8.04688 14C7.82036 14 7.59757 13.9423 7.39954 13.8323L2.73287 11.2396C2.52511 11.1242 2.35196 10.9554 2.23135 10.7507C2.11074 10.5459 2.04705 10.3126 2.04688 10.075V4.58429C2.04687 4.46544 2.07864 4.34875 2.13889 4.2463C2.19913 4.14386 2.28567 4.05938 2.38954 4.00162L7.39954 1.21895Z",
    stroke: "#006DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 2.52563L11.0469 5.85897V8.1923M4.04688 7.7443L6.04688 8.85897",
    stroke: "#006DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04688 4.19214L8.04688 7.52547M8.04688 7.52547L14.0469 4.19214M8.04688 7.52547V13.8588",
    stroke: "#006DFF",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/shipping-icon.69ab0720b0de1063a70cf5893fdc0029.svg";
export { ForwardRef as ReactComponent };